import {GrantStatus} from 'src/openapi/admin/models/GrantStatus';

import type {Grant} from 'src/openapi/admin/models/Grant';

export const GRANT_NAME_CONTROL = 'grant-name-control';
export const GRANT_NAME_REQUIRED_ERROR = 'grant-name-required-error';
export const GRANT_NAME_REQUIRED_MESSAGE = 'Grant Name is required field';

export const GRANT_DESCRIPTION_CONTROL = 'grant-description-control';
export const GRANT_DESCRIPTION_REQUIRED_ERROR = 'grant-description-required-error';
export const GRANT_DESCRIPTION_REQUIRED_MESSAGE = 'Grant Description is required field';

export const DEFAULT_GRANT: Grant = {
    id: '',
    name: '',
    description: '',
    status: GrantStatus.ALLOW,
    requiredApprovals: false,
};
